import React               from 'react';
import Input                from './Input';
import { studentStateType } from '../../types';
import heb                  from '../../utils/heb';
import { makeStyles }       from '@material-ui/core/styles';

const blue     = '#66C';
const darkblue = '#55B';

const useStyles = makeStyles(() => ({
    root: {
        position:      'absolute',
        left:          0,
        top:           0,
        width:         '100vw',
        overflowY:     'scroll',
        overflowX:     'hidden',
        paddingTop:    10,
        paddingBottom: 100,
        '&::-webkit-scrollbar': {
          width: '0.5em',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#DDD',
          borderRadius:    10
        }
      },
    title: {
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        height:         120,
        fontSize:       25,
        color:          '#334',
        textAlign:      'center',
        lineHeight:     1.8,
    },
    error: {
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        textAlign:      'center',
        height:         30,
        fontSize:       20,
        color:          '#F00',
    },
    submitButton: {
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        textAlign:       'center',
        position:        'absolute',
        left:            '50%',
        marginTop:       20,
        transform:       'translate(-50%, 0%)',
        width:           170,
        height:          50,
        backgroundColor: blue,
        color:           '#FFF',
        cursor:          'pointer',
        borderRadius:    '0.5em',
        boxShadow:       '0px 3px 10px 3px rgba(0,0,0,0.25)',
        '&:hover': {
            backgroundColor: darkblue,
        }
    }
}))


type FormType = {
    size:            number[];
    error:           string;
    quizName:        string;
    studentState:    studentStateType;
    setStudentState: (val: studentStateType) => void;
    handleSubmit:    () => void;

}

const Form: React.FC<FormType> = ({ 
    size,
    error,
    quizName,
    studentState,
    setStudentState,
    handleSubmit
}) => {

    const classes = useStyles();


    const contentRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        if (contentRef && contentRef.current && error.length) {
          contentRef.current.scrollIntoView();
        }
     },[contentRef, error])
     

    const arr = React.useMemo(() => {
        return Object.keys(studentState)
    },[studentState])

  
    return (
      <div 
          className = { classes.root }
          ref       = { contentRef }
      >
          <div className = { classes.title } dir = 'rtl'>
              { heb[`${ quizName }`] } 
              <br/>
              { `טופס הרשמה` }
          </div>
          <div className = { classes.error } dir = 'rtl'>
              { error }
          </div>
          {
              arr.map((val) => {

                  const variant = (val === 'allowNotifications' || val === 'arabic') ? 'checkBox' : 'text'

                  return(
                    <Input
                       size            = { size }
                       key             = { val }
                       val             = { val }
                       variant         = { variant }
                       studentState    = { studentState }
                       setStudentState = { setStudentState }
                    />
                  )
              })
          }
          <div 
              className = { classes.submitButton } 
              dir       = 'rtl'
              onClick   = { handleSubmit }
          >
              { `אישור` }
          </div>
      </div>
    );
}

export default Form;
